import React from 'react';
import {
  SwitchFormControlLabel,
  SwitchLabel,
  Switch as Toggle,
} from 'spw-components/global/styles';
import { CLIENT_NAMES_TOGGLE_CONTAINER_ID } from 'spw-constants';
import { useDispatch, useSelector } from 'react-redux';
import { selectClientFacingNamesAreVisible } from 'spw-redux/modules/space_types/selectors';
import { toggleClientFacingNamesAreVisible } from 'spw-redux/modules/space_types/actions';
import { ClientNamesToggleFormGroup } from './styles';

const ClientNamesToggle = ({ zIndex = 1 }: { zIndex?: number }) => {
  const dispatch = useDispatch();

  const clientFacingNamesAreVisible = useSelector(
    selectClientFacingNamesAreVisible
  );

  const handleClientFacingNamesToggle = () =>
    dispatch(toggleClientFacingNamesAreVisible());

  return (
    <ClientNamesToggleFormGroup
      id={CLIENT_NAMES_TOGGLE_CONTAINER_ID}
      data-cy="client-names-toggle-switch"
      aria-label="client facing names switch"
      row
      $zIndex={zIndex}
    >
      <SwitchFormControlLabel
        control={
          <Toggle
            checked={clientFacingNamesAreVisible}
            onChange={handleClientFacingNamesToggle}
            color="default"
          />
        }
        label={
          <SwitchLabel style={{ paddingTop: 1, fontWeight: 'normal' }}>
            Client Names
          </SwitchLabel>
        }
        labelPlacement="start"
      />
    </ClientNamesToggleFormGroup>
  );
};

export default ClientNamesToggle;
